import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 224-chevron-right
 * @see {GlyphIcon}
 */
const ChevronRightIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M23.32849,16.70709,13.12115,26.91425a.50007.50007,0,0,1-.70715,0l-2.82806-2.8285a.5.5,0,0,1,0-.70709L16.96436,16,9.58594,8.62134a.5.5,0,0,1,0-.70709L12.414,5.08575a.50007.50007,0,0,1,.70715,0L23.32849,15.29291A.99988.99988,0,0,1,23.32849,16.70709Z";
	}
}

export default ChevronRightIcon;
